module.exports = __webpack_public_path__ + "img/p5.0a6fc451.png";